import { render, staticRenderFns } from "./invoice-sales-add-or-update.vue?vue&type=template&id=6f335c3d&scoped=true"
import script from "./invoice-sales-add-or-update.vue?vue&type=script&lang=js"
export * from "./invoice-sales-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./invoice-sales-add-or-update.vue?vue&type=style&index=0&id=6f335c3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f335c3d",
  null
  
)

export default component.exports